import ProductItems from 'components/ProductItems';
import './styles.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { fetchRelatedProducts, selectRelatedProducts } from 'store/slices/ProductsSlice';
import { useParams } from 'react-router-dom';
import { ROUTES } from 'constants/routes';
import ButtonShowMore from 'components/Button/ButtonShowMore';

const RelatedProductsBox = ({ title }) => {
    const [page, setPage] = useState(1);
    const dispatch = useDispatch();
    const { slug } = useParams();
    const { data, next } = useSelector(selectRelatedProducts);

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchRelatedProducts({ slug, page }));
    }, [dispatch, slug, page]);

    const handleShowMore = () => setPage(page + 1);

    return (
        <div className="box product-box">
            {title && <h3>{title}</h3>}
            {data?.length > 0 && <ProductItems data={data} baseRoute={ROUTES.products} />}
            <ButtonShowMore next={next} onClick={handleShowMore} />
        </div>
    );
};
export default RelatedProductsBox;
